import { render, staticRenderFns } from "./AiEventAlarmSet - 副本.vue?vue&type=template&id=4d837b9e&scoped=true"
import script from "./AiEventAlarmSet - 副本.vue?vue&type=script&lang=js"
export * from "./AiEventAlarmSet - 副本.vue?vue&type=script&lang=js"
import style0 from "./AiEventAlarmSet - 副本.vue?vue&type=style&index=0&id=4d837b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d837b9e",
  null
  
)

export default component.exports